<template>
  <br style="margin-top: 40px;">
          <!-- subscriptions -->
          <section class="section">
              <div class="container">
                  <div class="row">
                  </div>
              </div>
          </section>
          <template v-for="CatInfo in info" :key="CatInfo.id">

          <div class="section__bg" v-bind:style="{ 'background': 'url(' + CatInfo.trailer_img + ')' , 'background-size': 'cover', 'background-position': 'top' }">
          </div>
          </template>
          <!-- end subscriptions -->
  
          <!-- catalog -->
          <div class="catalog2 catalog--page">
              <div class="container">
                  <div class="row">
                    <div class="col-12 " style="z-index:99" dir="rtl">
                      <template v-for="CatInfo in info" :key="CatInfo.id">

                          <!-- trailer -->
                          <a href="#" class="article__trailer open-video" savefrom_lm_index="0" savefrom_lm="1">
                          <!-- <img class="trailer_img" v-lazy="CatInfo.img" style="width:120px"/> -->
                          
                          </a>
                          
                          <div class="article__content" style="margin-top: -4vh;">
                              <h1 class="trailer_header" style="text-align: right;font-family: 'Cairo' , sans-serif;font-weight: bold;font-size: 3rem;">{{CatInfo.name_ar}}</h1>
                          <p class="trailer_header" style="text-align:right">{{CatInfo.desc_ar}}</p>
                        
                        </div>
                      </template>
                          <!-- end article content -->
                 </div>
                      <!-- <div class="col-12">
                          <ul class="title"><li style="margin-left: 30px;margin-right: 10px;"><h6 > التصنيف </h6></li><li style="margin-left: 30px;">-</li><li style="margin-left: 30px;"><h6 >أبعاد صحية</h6></li></ul>
                      </div> -->
                      <div class="col-12">
                          <div class="row row--grid">
                              <div class="col-12 col-sm-4 col-lg-3 col-xl-4" v-for="publish in art" :key="publish.id">
                                <div class="card">
                                    <a class="card__cover" @click="getFeed(publish)">
                                        <img alt="" v-lazy="publish.img">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 1C16.5228 1 21 5.47716 21 11C21 16.5228 16.5228 21 11 21C5.47716 21 1 16.5228 1 11C1 5.47716 5.47716 1 11 1Z" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0501 11.4669C13.3211 12.2529 11.3371 13.5829 10.3221 14.0099C10.1601 14.0779 9.74711 14.2219 9.65811 14.2239C9.46911 14.2299 9.28711 14.1239 9.19911 13.9539C9.16511 13.8879 9.06511 13.4569 9.03311 13.2649C8.93811 12.6809 8.88911 11.7739 8.89011 10.8619C8.88911 9.90489 8.94211 8.95489 9.04811 8.37689C9.07611 8.22089 9.15811 7.86189 9.18211 7.80389C9.22711 7.69589 9.30911 7.61089 9.40811 7.55789C9.48411 7.51689 9.57111 7.49489 9.65811 7.49789C9.74711 7.49989 10.1091 7.62689 10.2331 7.67589C11.2111 8.05589 13.2801 9.43389 14.0401 10.2439C14.1081 10.3169 14.2951 10.5129 14.3261 10.5529C14.3971 10.6429 14.4321 10.7519 14.4321 10.8619C14.4321 10.9639 14.4011 11.0679 14.3371 11.1549C14.3041 11.1999 14.1131 11.3999 14.0501 11.4669Z" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </a>
                                    <h3 class="card__title">
                                        <a>{{ publish.title_ar }}</a>
                                    </h3>
                                </div>
                                  <!-- <div class="cardBox">
                                    <div class="card">
                                        <a @click="getFeed(publish)" class="card__cover" style="height: 230px;">
                                            <img v-lazy="publish.img" alt="">
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 1C16.5228 1 21 5.47716 21 11C21 16.5228 16.5228 21 11 21C5.47716 21 1 16.5228 1 11C1 5.47716 5.47716 1 11 1Z" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0501 11.4669C13.3211 12.2529 11.3371 13.5829 10.3221 14.0099C10.1601 14.0779 9.74711 14.2219 9.65811 14.2239C9.46911 14.2299 9.28711 14.1239 9.19911 13.9539C9.16511 13.8879 9.06511 13.4569 9.03311 13.2649C8.93811 12.6809 8.88911 11.7739 8.89011 10.8619C8.88911 9.90489 8.94211 8.95489 9.04811 8.37689C9.07611 8.22089 9.15811 7.86189 9.18211 7.80389C9.22711 7.69589 9.30911 7.61089 9.40811 7.55789C9.48411 7.51689 9.57111 7.49489 9.65811 7.49789C9.74711 7.49989 10.1091 7.62689 10.2331 7.67589C11.2111 8.05589 13.2801 9.43389 14.0401 10.2439C14.1081 10.3169 14.2951 10.5129 14.3261 10.5529C14.3971 10.6429 14.4321 10.7519 14.4321 10.8619C14.4321 10.9639 14.4011 11.0679 14.3371 11.1549C14.3041 11.1999 14.1131 11.3999 14.0501 11.4669Z" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                            <div class="shotal">
                                                <h3 class="card__title" ><a @click="getFeed(publish)">{{ publish.title_ar }}</a></h3>
                                                <ul style="justify-content: center;" class="card__list">
                                                    <li style="margin-left: 0;">{{ publish.name_ar }}</li>
                                                    <li></li>
                                                </ul>
                                            </div>
                                        </a>
                                    </div>
                                  </div> -->
                              </div>
                          </div>
                      </div>
                  </div>		
              </div>
          </div>
</template>

<script>
import { HTTP } from '@/Api/http-common';
  import { ref } from '@vue/reactivity';
  import { useRouter } from "vue-router"
  import { useCookie } from 'vue-cookie-next'
export default {
     name: 'AppCategory',
     props:{
        id:String
     },
     async setup(props) {
      const router = useRouter();
      const cookie = useCookie();
      const art = ref([]);
      const info = ref([]);
 
      try {
        await HTTP.get(`GetContentByCategory.php?LIMIT=100&OFFSET=0&cat_id=${props.id}`).then((res) => {
          art.value = res.data.Content; 
        });
      } catch (err) {
        console.log(err);
      }
      try {
        await HTTP.get(`GetCategoryInfo.php?ID=`+props.id).then((res) => {
          info.value = res.data.CategoryInfo; 
        });
      } catch (err) {
        console.log(err);
      }
      // try {
      //   await HTTP.get(`GetArtistsByCategory.php?ID=4`).then((res) => {
      //     Artists.value = res.data.Artists; 
      //   });
      // } catch (err) {
      //   console.log(err);
      // }
      const getFeed = (publish) => {
        cookie.setCookie('cat_id', publish.cat_id);
        if(cookie.isCookieAvailable("msisdn") && cookie.isCookieAvailable("status")) {
                router.push({ name: "Content", params: { content_id: publish.id } });
            } else {
                cookie.setCookie('content_id', publish.id);
                window.open("https://dsplp.sd.zain.com/?p=9619984619", "_blank");	
            }
      };
      // const GoToArtistsContent = (publish) => {
      //   if(cookie.isCookieAvailable("artist_id")){
      //     cookie.removeCookie("artist_id")
      //   }
      //   cookie.setCookie('artist_id', publish.id)
      //   router.push("/ArtistContent");
      // };
        return { info,art, getFeed };
    },

}
</script>

<style>

</style>